import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	description: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	learnMoreAction: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	dismissAction: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	title: {
		defaultMessage: 'Your top navigation menu has custom colors',
		id: 'custom-nav-bar-colors-flag.title',
		description:
			"Title of the flag that is displayed when the theme is switched and the user's organisation has a custom top nav bar color",
	},
	description: {
		defaultMessage:
			"If the color of your navigation menu doesn't look right in this theme, notify your Jira admin.",
		id: 'custom-nav-bar-colors-flag.description',
		description:
			"Description in the flag that is displayed when the theme is switched and the user's organisation has a custom top nav bar color",
	},
	learnMoreAction: {
		defaultMessage: 'Learn more',
		id: 'custom-nav-bar-colors-flag.learn-more-action',
		description:
			"A link to the support page, shown in the flag that is displayed when the theme is switched and the user's organisation has a custom top nav bar color",
	},
	dismissAction: {
		defaultMessage: 'Dismiss',
		id: 'custom-nav-bar-colors-flag.dismiss-action',
		description:
			"An action butotn to dismiss the flag that is displayed when the theme is switched and the user's organisation has a custom top nav bar color",
	},
});
export default messages;
